<sb-dashboard-widget
  [isLoading]="isLoading()"
  [isEmpty]="departmentForecasts().length === 0"
  [title]="'Weather forecast' | translate"
  [emptySettings]="{
    description: 'Add locations to see the weather forecast for your departments.' | translate,
    icon: 'sun-cloudy-cute-re',
  }"
>
  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th>{{ 'Name' | translate }}</th>
        @for (date of dates; track $index) {
          <th class="w-14 text-center" [ngClass]="{ 'hidden xl:table-cell': $index > 2 }">
            {{ date | localeDate: 'weekdayShort' }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (departmentForecast of departmentForecasts(); track departmentForecast.id) {
        <tr>
          <td class="px-3">{{ departmentForecast.location_name }}<br />{{ departmentForecast.department_name }}</td>
          @for (forecast of departmentForecast.forecast; track forecast.date) {
            <td class="px-1 py-2 last:pr-3" [ngClass]="{ 'hidden xl:table-cell': $index > 2 }">
              <div class="flex flex-col items-center gap-1">
                <sb-weather-icon [weatherType]="forecast.weather_type" [size]="'xl'" />
                <span class="text-xs">{{ forecast.temp_min_celcius }}°/{{ forecast.temp_max_celcius }}°</span>
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
